var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.8266897,14.015931 C27.8266897,21.5735172 21.6995172,27.7006897 14.141931,27.7006897 C6.58434483,27.7006897 0.457172414,21.5735172 0.457172414,14.015931 C0.457172414,6.45834483 6.58434483,0.331172414 14.141931,0.331172414 C21.6995172,0.331172414 27.8266897,6.45834483 27.8266897,14.015931 L27.8266897,14.015931 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag-popup",
    transform: "translate(-388.000000, -567.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(387.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1723",
    transform: "translate(0.916016, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-1720"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1719",
    fill: "#002395",
    mask: "url(#mask-2)",
    points: "0.457172414 27.7002069 9.12413793 27.7002069 9.12413793 0.331172414 0.457172414 0.331172414"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1721",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "9.12413793 27.7002069 19.1597241 27.7002069 19.1597241 0.331172414 9.12413793 0.331172414"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1722",
    fill: "#ED2939",
    mask: "url(#mask-2)",
    points: "19.1597241 27.7002069 27.8266897 27.7002069 27.8266897 0.331172414 19.1597241 0.331172414"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.85cf6f25ba4f71e10be98827350e69a4.svg";
export { ForwardRef as ReactComponent };